import { toPlainText } from '@portabletext/react'
import { useMemo } from 'react'

import { ArticleCarouselRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { CarouselCardRebrand } from 'src/components/molecules/CarouselCardRebrand'

import { viewBlogPostPath } from 'src/config/paths'
import { ArrayElement } from 'src/types/common'
import { getSanityImageUrl } from 'src/utils/sanity'

import CarouselRebrand from '../CarouselRebrand/CarouselRebrand'

type CarouselArticleProps = ArrayElement<
  NonNullable<ArticleCarouselRebrandResult['articles']>
> & {
  isOnlyArticle?: boolean
}

const CarouselArticle = ({
  title,
  description,
  image,
  article,
  backgroundColor,
  isOnlyArticle
}: CarouselArticleProps) => {
  const articleTitle = useMemo(() => {
    return title || article.title
  }, [title, article.title])

  const descriptionText = useMemo(() => {
    return description || toPlainText(article.summary || [])
  }, [description, article.summary])

  const imageUrl = useMemo(() => {
    if (image) {
      return getSanityImageUrl(image, 640, 480)
    }
    if (article.mainImage) {
      return getSanityImageUrl(article.mainImage, 640, 480)
    }
  }, [image, article.mainImage])

  return (
    <CarouselCardRebrand
      isOnlyCard={isOnlyArticle}
      backgroundColor={backgroundColor}
      title={articleTitle}
      titleHref={viewBlogPostPath({
        routeParams: {
          slug: article.slug.current
        }
      })}
      description={descriptionText}
      imageUrl={imageUrl!}
    />
  )
}

const ArticleCarouselRebrand = ({
  articles,
  title,
  description,
  backgroundColor
}: ArticleCarouselRebrandResult) => {
  const isSingleArticle = useMemo(
    () => articles?.length === 1,
    [articles?.length]
  )

  if (!articles || articles.length === 0) {
    return null
  }

  return (
    <CarouselRebrand
      backgroundColor={backgroundColor}
      title={title}
      description={description}
    >
      {articles.map(article => (
        <CarouselArticle
          isOnlyArticle={isSingleArticle}
          key={article.name}
          {...article}
        />
      ))}
    </CarouselRebrand>
  )
}

export default ArticleCarouselRebrand
